import(/* webpackMode: "eager" */ "/app/src/app/rebott-manual/page.tsx");
